export const customRound = (value: number, thresholdDecimalPart: number = 0.5): number => {
  const decimalPart = value % 1;

  if (decimalPart === thresholdDecimalPart) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  }

  return Math.round(value);
};
